// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._2rko1l5z{border-radius:var(--ds-br)}._152tze3t{inset-block-start:var(--ds-space-0,0)}
._1bah1h6o{justify-content:center}
._1e0c1txw{display:flex}
._4cvr1h6o{align-items:center}
._4t3i7vkz{height:1pc}
._kqswstnw{position:absolute}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/node_modules/@atlaskit/tag/dist/esm/tag/internal/shared/before.compiled.css"],"names":[],"mappings":";AACA,WAAW,0BAA0B,CAAC,WAAW,qCAAqC;AACtF,WAAW,sBAAsB;AACjC,WAAW,YAAY;AACvB,WAAW,kBAAkB;AAC7B,WAAW,UAAU;AACrB,WAAW,iBAAiB","sourcesContent":["\n._2rko1l5z{border-radius:var(--ds-br)}._152tze3t{inset-block-start:var(--ds-space-0,0)}\n._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4t3i7vkz{height:1pc}\n._kqswstnw{position:absolute}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
